import * as PIXI from 'pixi.js'
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import { Signals} from "@/Imports";
import Config from "@/config/Config";
import BaseSymbol from "@base/symbols/BaseSymbol";
import GameSignals from "@/signals/GameSignals";

export default class AnimationSymbol extends BaseSymbol {

    constructor(data) {
        super(data)
    }

    init(index) {
        this.symbolIndex = index
        this.currentName = 'create'
        this.symbolContainer = new PIXI.Container()
        this.symbolContainer.on('pointerdown', this.onSymbolTap, this)
        this.symbolContainer.interactive = true
        this.addChild( this.symbolContainer)
        this.build(index)
    }

    build(data) {
        this.currentSymbolName = Config.symbolAnimationNames[data]
        this.animations = this.createAnimationList(Config.animationList)
        this.animations[this.currentSymbolName].visible = true
        this.changePositionByIndex(data);

        //Signals.startSpin.add(this.startSpin, this)
    }

    setMultiplierSymbol(index){
        this.IndexMultiplier = index
    }

    startSpin() {
        this.symbolName = ''
        this.animations[this.currentSymbolName].start(['stop_ani'], [false])//, 0.7)
        //   setTimeout(() => {this.landing.alpha = 0}, 500)
    }

    changeTextureByIndex(index) {
        this.animations[this.currentSymbolName].visible = false
        this.symbolIndex = index
        this.currentName = 'create'
        this.currentSymbolName = Config.symbolAnimationNames[index]
        this.animations[this.currentSymbolName].stop()
        this.animations[this.currentSymbolName].timeScale = 1
        //trackEntry.trackTime = trackEntry.animation.duration
        this.animations[this.currentSymbolName].visible = true
        this.changePositionByIndex(index)
    }

    changePositionByIndex(index){
        const position = Config.symbolsPosition && Config.symbolsPosition[index] || [0,0]
        this.symbolContainer.position.set(position.x, position.y)
    }

    onSymbolTap(e) {
        e.stopPropagation()
        GameSignals.symbolTap.dispatch(this)
    }

    createAnimationList (listName) {
        const listAnimation = {}
        listName.map(name => {
            //console.log('createAnimationList',name)
            const animationSymbol = new SpineAnimation(name)
            animationSymbol.interactive = false
            animationSymbol.visible = false
            listAnimation[name] = animationSymbol
           // this.spr.pivot.set(this.spr.width / 2, this.spr.height / 2)
            this.symbolContainer.addChild(animationSymbol)
        })
        return listAnimation
    }

    showAnimationStop(){
        if (this.currentName !== 'win' ){
            this.currentName = 'stop'
            this.animations[this.currentSymbolName].stop()
         //   this.animations[this.currentSymbolName].start(['stop_ani'], [false])//, 0.7)
        }
    }

    disappear(){
        this.currentName = 'disappear'
        this.animations[this.currentSymbolName].stop()
        this.animations[this.currentSymbolName].start(['disappear_ani'], [false], 1.3)
    }

    win(){
        console.log('win  ', this.currentSymbolName, this.symbolIndex )
        this.currentName = 'win'
        this.animations[this.currentSymbolName].stop()
        this.animations[this.currentSymbolName].start(['win_ani'], [true])
        this.parent.addChild(this)
    }

    start = () => {
        console.log('start')
        //this.showAnimationStop()

    }
}
